import React from 'react';
import './BonvoyStatsIntro.css';
import bonvoyTitleDesktop from 'url:../../assets-optimized/redesign/text/marriott_bonvoy.png';
import bonvoyTitleMobile from 'url:../../assets-optimized/redesign/text/marriott_bonvoy_mobile.png';

const BonvoyStatsIntro = () => {
  const scrollToStats = () => {
    const element = document.getElementById('bonvoy-stats-grid');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className='container-fixed bonvoy-stats-intro '>
      <div className='bonvoy-title-image'>
        <span className='powered-by'>Powered by</span>{' '}
        <span className='all-caps'>
          the largest loyalty program in travel, <span className='no-wrap'>Marriott Bonvoy</span>
        </span>
      </div>
      <p>
        With nearly 10,000 properties worldwide, our reach is grounded in over a century of trust,
        unlocking access to real-world traveler behavior at a global scale.
      </p>
      <div className='arrow-down' onClick={scrollToStats}>
        <svg viewBox='0 0 24 24'>
          <path d='M12 5v14M5 12l7 7 7-7' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      </div>
    </div>
  );
};

export default BonvoyStatsIntro;
